import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";

// 1. Create a base "input selector" to get the language slice from the root state.
const selectLanguageState = (state: RootState) => state.language;

/**
 * Memoized selector to derive language information.
 * Returns the current language, default language, and a boolean
 * indicating if translation should be applied.
 */
export const selectLanguageInfo = createSelector(
  [selectLanguageState],
  (languageState) => {
    const { currentLanguage, defaultLanguage } = languageState;
    return {
      currentLanguage,
      defaultLanguage,
      shouldTranslate: currentLanguage !== defaultLanguage,
    };
  }
);
